module.exports = require('../math/sum');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/collection/sum.js
 ** module id = 174
 ** module chunks = 0
 **/